import Vue from 'vue';

// 当前家庭中有周报告的孩子
export function weeklyReportChildren () {
  return Vue.axios({
    url: '/api/parent/weeklyReport/children',
    method: 'get'
  })
}

// 周报告列表
export function weeklyReportList (params) {
  return Vue.axios({
    url: '/api/parent/weeklyReport/list',
    method: 'get',
    params: params
  })
}

// 周报告详情
export function weeklyReportDetail (params) {
  return Vue.axios({
    url: '/api/parent/weeklyReport/detail',
    method: 'get',
    params: params
  })
}

// 留言列表（同时标记已读）
export function weeklyReportComments (params) {
  return Vue.axios({
    url: '/api/parent/weeklyReport/comments',
    method: 'get',
    params: params
  })
}

// 发表留言
export function weeklyReportCommentSave (data) {
  return Vue.axios({
    url: '/api/parent/weeklyReport/comment',
    method: 'post',
    data: data
  })
}
